const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SearchCtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (window.BAO.MediaBreakpoints.isLg) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.75,
          spacing: 10,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('search-cta-carousel')) {
  customElements.define('search-cta-carousel', SearchCtaCarousel)
}
